import useAppQuery from '../../../hooks/useAppQuery';
import IntegrationsAPI from '../../../services/IntegrationsAPI';
import { GetPremiumDbsSiteStatusResponse } from './AgencySettingsDbs.types';

export const PREMIUM_DBS_SITE_STATUS_BASE_QUERY_KEY = 'premiumDbsSiteStatus';

// The endpoint answers 204 for an agency without a premium site, so an empty body is the
// "not connected yet" signal rather than an error.
const useFetchPremiumDbsSiteStatus = ({
  agencyUid,
  enabled = false,
}: {
  agencyUid: string;
  enabled?: boolean;
}) => {
  return useAppQuery<GetPremiumDbsSiteStatusResponse | null>({
    queryKey: [PREMIUM_DBS_SITE_STATUS_BASE_QUERY_KEY, agencyUid],
    queryFn: async () => {
      const response = await IntegrationsAPI.get(
        `/api/internal/edbs/site-status/${agencyUid}`,
      );

      return response.data || null;
    },
    enabled,
  });
};

export default useFetchPremiumDbsSiteStatus;
